import IS_CLIENT_RENDERED from "./isClientRendered";

let scrollToElement;
if (IS_CLIENT_RENDERED) {
  scrollToElement = require("scroll-to-element");
} else {
  scrollToElement = () => null;
}

export default scrollToElement;



// WEBPACK FOOTER //
// ./src/util/scrollToElement.js